import * as React from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import * as Style from "./style"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  Grid,
  Pagination,
  Stack,
} from "@mui/material"

import { Button } from "react-bootstrap"
import { FiDownload } from "react-icons/fi"
import { useState, useEffect } from "react"
import { useGetiNvoiceQuery } from "../../features/OverViewAuth/overViewApi"
import { useSearchParams } from "react-router-dom"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import noDataHistory from "../../images/no-history.png"
import CenteredSpinner from "../common/CenteredSpinner"

export default function BasicTabs() {
  const [listmonth, setListMonth] = useState<string>("")

  // Time Zone funtion

  const [timeZone, setTimeZone] = useState("")

  useEffect(() => {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (timeZone === "Asia/Calcutta") {
      timeZone = "Asia/Kolkata"
    }
    setTimeZone(timeZone)
  }, [])

  // for select date

  const [minDate, setMinDate] = useState("")
  const [maxDate, setMaxDate] = useState("")

  const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const handleMonth = (e: any) => {
    setSelectedPage(1)
    const value = e.target.value || getCurrentMonth();
    setListMonth(value)
  }

  useEffect(() => {
    const now = new Date()
    const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1)
    const max = `${currentMonth.getFullYear()}-${String(
      currentMonth.getMonth() + 1,
    ).padStart(2, "0")}`

    const min = `${now.getFullYear()}-01`

    setMaxDate(max)
    setMinDate(min)
  }, [])

  useEffect(() => {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const currentMonthValue = `${year}-${month}`
    setListMonth(currentMonthValue)
  }, [])

  const [selectedPage, setSelectedPage] = useState(1)

  const {
    data: invoiceGet,
    isFetching,
    isLoading,
  } = useGetiNvoiceQuery(
    {
      pageNo: selectedPage,
      timeZone: timeZone,
      filterDate: listmonth + "-01",
      pageLimit: 10,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  const handlePageChange = (event: any, value: any) => {
    setSelectedPage(value)
  }

  // View payment details

  const viewDetailsPayment = (
    event: React.MouseEvent<HTMLElement>,
    imageUrl: any,
  ) => {
    event.stopPropagation()
    const url = imageUrl
    const newTab = window.open(url, "_blank")
    if (newTab) {
      newTab.focus()
    } else {
      console.error("Failed to open new tab.")

      window.location.href = url
    }
  }

  return (
    <>
      <Style.Overview>
        <Box style={{ marginBottom: "20px" }}>
          <div className="w-100">
            <FormControl
              sx={{ m: 1, width: 100, mt: 3 }}
              className="custom-field view-field"
            >
              <input
                id="demo-simple-select"
                type="month"
                onChange={handleMonth}
                placeholder="Select Date"
                style={{
                  borderRadius: "12px",
                  width: "180px",
                  backgroundColor: "#fff",
                  padding: "13px 17px",
                  border: "1px solid #C1C1C1",
                  color: listmonth ? "#000" : "#fff",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "textfield",
                  lineHeight: "normal",
                  textAlign: "left",
                }}
                min={minDate}
                max={maxDate}
                value={listmonth}
                onFocus={(e) => e.target.style.color = "#000"}
                onBlur={(e) => {
                  if (!e.target.value) {
                    const currentMonth = getCurrentMonth();
                    setListMonth(currentMonth);
                    e.target.value = currentMonth;
                    e.target.style.color = "#000";
                  }
                }}
                />
            </FormControl>
          </div>{" "}
        </Box>
      </Style.Overview>

      <Style.Overview>
        <Box sx={{ width: "100%" }}>
          <TableContainer
            component={Paper}
            className="dashboard-table-wrapper custom-scrollbar overflow-y-hidden"
          >
            <Table
              style={{
                minWidth: 650,
                border: "none",
                backgroundColor: "#fff",
                borderRadius: "16px",
                overflow: "hidden",
              }}
              className="dashboard-table1"
              aria-label="simple table"
            >
              {invoiceGet?.message?.length > 0 && (
                <TableHead>
                  <TableRow>
                    <TableCell align="center" className="service-head">
                      Billing Date
                    </TableCell>
                    <TableCell align="center">Booked Service</TableCell>
                    <TableCell align="center"> Billing Amount</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Download</TableCell>
                  </TableRow>
                </TableHead>
              )}

              {isLoading || isFetching ? (
                <>
                  {" "}
                  <CenteredSpinner />
                </>
              ) : (
                <TableBody>
                  {invoiceGet?.message?.length > 0 ? (
                    invoiceGet?.message?.map((row: any, index: number) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          cursor: "pointer",
                        }}
                      >
                        <TableCell align="center">
                          <span className="datetime">
                            {row?.postId[0]?.from ? (
                              <span className="d-flex flex-column">
                                <span className="weekday">
                                  <FormatDate
                                    dateString={row?.postId[0]?.from}
                                  />
                                </span>
                                <span>
                                  <FormatTime
                                    dateString={row?.postId[0]?.from}
                                  />
                                </span>
                                <span>
                                  <FormatChangeTime
                                    dateString={row?.postId[0]?.from}
                                  />
                                </span>
                              </span>
                            ) : (
                              <span>Invalid</span>
                            )}
                          </span>
                        </TableCell>

                        <TableCell align="center">
                          <span
                            className={row.payment}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              color: !row?.postId[0]?.service[0]?.name
                                ? "red"
                                : "inherit",
                            }}
                          >
                            {row?.postId[0]?.service[0]?.name
                              ? row?.postId[0]?.service[0]?.name
                              : "Not Service"}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span
                            className={row.payment}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            C$ {row?.totalAmount}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span
                            className={row.payment}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              className="payment-btn"
                              style={{
                                color:
                                  row?.paymentStatus == "Pending"
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {row?.paymentStatus == "Pending"
                                ? "Pending"
                                : row?.paymentStatus == "Success"
                                ? "Paid"
                                : row?.paymentStatus}
                            </Button>
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          {row?.postId[0]?.receipt_url ? (
                            <span
                              className={row.payment}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                              onClick={(e: any) =>
                                viewDetailsPayment(
                                  e,
                                  row?.postId[0]?.receipt_url as any,
                                )
                              }
                            >
                              <FiDownload
                                style={{ marginLeft: "5px", fontSize: "20px" }}
                              />
                            </span>
                          ) : (
                            <span>Pending</span>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={7}
                        sx={{
                          width: "100%",
                          pointerEvents: "none",
                          border: "none",
                          height: "498px",
                          padding: 0,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <img
                            src={noDataHistory}
                            alt="No Booking History"
                            style={{
                              width: "100%",
                              maxWidth: "208px",
                              marginBottom: "12px",
                            }}
                          />
                          <span
                            className="no-data-text"
                            style={{ fontSize: "16px", color: "#000" }}
                          >
                            No Invoice History
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Box>
        {invoiceGet?.message?.length > 0 && (
          <Box className="d-md-flex justify-content-between align-items-center mt-3">
            <Typography variant="body1" className="white-space">
              {" "}
              Showing {invoiceGet?.paginationData?.showingData} /{" "}
              {invoiceGet?.paginationData?.total} Total
            </Typography>
            <Grid container justifyContent="flex-end">
              <Grid item md={3}>
                <Box display="flex" className="flex-column">
                  <Stack spacing={2} className="mb-3">
                    <Pagination
                      count={invoiceGet?.paginationData?.totalPages}
                      color="secondary"
                      className="custom-pagination"
                      page={selectedPage}
                      onChange={handlePageChange}
                      sx={{
                        "& .MuiPaginationItem-page.Mui-selected": {
                          backgroundColor: "#F475A4",
                          boxSizing: "border-box",
                        },
                        "& .css-wjh20t-MuiPagination-ul": {
                          flexWrap: "nowrap",
                          justifyContent: "end",
                        },
                      }}
                    />
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Style.Overview>
    </>
  )
}
